import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type ManageDriftDetectionDeleteConfirmationModalProps = {
  onConfirm: () => void;
};

const ManageDriftDetectionDeleteConfirmationModal = create(
  function ManageDriftDetectionDeleteConfirmationModal({
    onConfirm,
  }: ManageDriftDetectionDeleteConfirmationModalProps) {
    const modal = useModal();

    const handleOnConfirm = () => {
      modal.resolve();
      modal.hide();
      onConfirm();
    };

    return (
      <ConfirmationModal
        title="Delete scheduling"
        confirmationButtonLabel="Delete"
        confirmationButtonVariant="dangerPrimary"
        onConfirm={handleOnConfirm}
      >
        <ConfirmationModalMessage>
          Are you sure you want to delete <strong>Drift detection</strong> scheduling?
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showManageDriftDetectionDeleteConfirmationModal = (
  props: ManageDriftDetectionDeleteConfirmationModalProps
) => show(ManageDriftDetectionDeleteConfirmationModal, props);
